import axios from 'axios';
import API_CONFIG from '../config/api';

/**
 * Zentrale Axios-Konfiguration.
 *
 * Die Seiten verwenden weiterhin die globale axios-Instanz, damit es nur
 * eine Stelle gibt, an der Basis-URL, Timeout und Token gesetzt werden.
 */
axios.defaults.baseURL = API_CONFIG.baseURL;
// Vorher war der konfigurierte Timeout ungenutzt: bei einem hängenden Server
// drehte sich die Ladeanimation endlos weiter.
axios.defaults.timeout = API_CONFIG.timeout;
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

export const setzeAuthToken = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

/**
 * Holt die für den Nutzer sinnvollste Fehlermeldung aus einem Axios-Fehler.
 *
 * Das Backend antwortet einheitlich mit `{ message }`; zusätzlich werden
 * Netzwerk- und Timeout-Fälle unterschieden, weil "Serverfehler" dort
 * irreführend wäre.
 */
export const fehlerText = (error: unknown, standard = 'Ein Fehler ist aufgetreten'): string => {
  if (axios.isAxiosError(error)) {
    if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
      return 'Der Server antwortet nicht. Bitte später erneut versuchen.';
    }

    if (!error.response) {
      return 'Server nicht erreichbar. Bitte prüfen Sie Ihre Verbindung.';
    }

    const daten = error.response.data as { message?: string } | undefined;
    if (daten?.message) {
      return daten.message;
    }

    if (error.response.status === 403) {
      return 'Für diese Aktion fehlt Ihnen die Berechtigung.';
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return standard;
};

export default axios;
